import * as React from "react";
import { StandardProps } from "@material-ui/core";
import MuiDivider, { DividerClassKey as MuiDividerClassKey } from "@material-ui/core/Divider";


export type DividerClassKey = MuiDividerClassKey;

export interface DividerProps
    extends StandardProps<React.HTMLAttributes<HTMLHRElement>, DividerClassKey> {
    absolute?: boolean;
    component?: React.ReactType<DividerProps>;
    inset?: boolean;
    light?: boolean;
}



class Divider extends React.PureComponent<DividerProps> {
    render() {
        const { ...props } = this.props;
        return <MuiDivider {...props}>
            {this.props.children}
        </MuiDivider>;
    }
}

export default Divider;